import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Inject, PLATFORM_ID, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: 'img[appLazyLoad]'
})
export class LazyLoadDirective implements AfterViewInit {
    @HostBinding('attr.src') srcAttr = null;
    @Input() src: string;
    @Output() lodedImage: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: any) { }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage();
        }
    }

    private canLazyLoad() {
        if (isPlatformBrowser(this.platformId)) {
            return window && 'IntersectionObserver' in window;
        }
    }

    private lazyLoadImage() {
        const obs = new IntersectionObserver(entries => {
            entries.forEach(({ isIntersecting }) => {
                if (isIntersecting) {
                    this.loadImage();
                    obs.unobserve(this.el.nativeElement);
                }
            });
        });
        obs.observe(this.el.nativeElement);
    }

    private loadImage() {
        this.srcAttr = this.src;
        this.lodedImage.emit(true);
    }
}